export default "__VITE_ASSET__Bj2f_FFE__";